import g from '#core/global';
import events from '#core/events';
import load from '#core/load';
import expandable from '#partial/expandable/expandable';


const option_input_$ = '.toggle-field-option__input';
const field_group_id_attr = 'data-field-group';
const hide_elements_attr = 'data-hide-elements';
const hide_elements_delimiter = ', ';
const name_attr = 'name';
const contains_attr = 'data-contains';

let has_option = false;
let $options = null;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('toggle-field-option')) return false;
		
		load.content(() => {
			has_option = assign_elements();
			if (!has_option) return false;
		});
		load.all(() => {
			has_option = assign_elements();
			if (!has_option) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_option) return true;
	
	// TODO: do not store objects on load, account for dynamic content
	$options = document.querySelectorAll(option_input_$);
	if (!$options.length) return false;
	
	$options.forEach($option => {
		const name = $option.getAttribute(name_attr);
		const related_options_$ = `${option_input_$}[${name_attr}="${name}"]`;
		const $related_options = document.querySelectorAll(related_options_$);
		if (!$related_options) return false;
		
		$option.addEventListener(g.change_e, e => {
			toggle_visible_elements($related_options);
			toggle_field_groups($related_options);
			document.dispatchEvent(new CustomEvent(events.filter.update_field_names));
		});
	});
	
	return true;
}


/**
 * Toggle visible elements
 * @param {NodeList} $related_options
 */
function toggle_visible_elements($related_options) {
	let show = [];
	let hide = [];
	
	$related_options.forEach($related_option => {
		let hide_elements = $related_option.getAttribute(hide_elements_attr) || '';
		hide_elements = hide_elements.split(hide_elements_delimiter);
		hide_elements = hide_elements.filter(x => x);
		
		if ($related_option.checked) {
			hide.push(...hide_elements);
		} else {
			show.push(...hide_elements);
		}
	});
	
	show = show.filter((id, index) => show.indexOf(id) === index);
	hide = hide.filter((id, index) => hide.indexOf(id) === index);
	
	show.forEach(id => {
		if (hide.includes(id)) return false;
		
		const $container = document.querySelector(`[${contains_attr}="${id}"]`);
		$container.removeAttribute(g.hidden_attr);
	});
	
	hide.forEach(id => {
		const $container = document.querySelector(`[${contains_attr}="${id}"]`);
		$container.setAttribute(g.hidden_attr, '');
	});
}


/**
 * Toggle field groups
 * @param {NodeList} $related_options
 */
function toggle_field_groups($related_options) {
	$related_options.forEach($related_option => {
		const id = $related_option.getAttribute(field_group_id_attr);
		if (!id) return false;
		
		expandable.toggle({
			id: id,
			force: $related_option.checked,
		});
		
		// Toggle container visibility
		if ($related_option.checked) {
			document.querySelector(`#${id}`).removeAttribute(g.hidden_attr);
		} else {
			document.querySelector(`#${id}`).setAttribute(g.hidden_attr, '');
		}
	});
}
